import { Injectable } from '@angular/core';
import { ApiService } from '@services/api.service';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';
import { ManagementGlobalAlertModel, ManagementGlobalAlertUpdateModel } from '@data-layer/models/management';

@Injectable({
  providedIn: 'root',
})
export class GlobalAlertsManagementRepository {
  constructor(private apiService: ApiService) {}

  public getGlobalAlerts(isShowLoader: boolean = true): Observable<ManagementGlobalAlertModel[]> {
    return this.apiService.get(`${environment.url.prefixCustoms}v2/management/global-alerts`, null, { isShowLoader });
  }

  public AddGlobalAlert(data: ManagementGlobalAlertUpdateModel, isShowLoader: boolean = true): Observable<void> {
    return this.apiService.post(`${environment.url.prefixCustoms}v2/management/global-alerts`, data, null, { isShowLoader });
  }

  public UpdateGlobalAlert(id: number, data: ManagementGlobalAlertUpdateModel, isShowLoader: boolean = true): Observable<void> {
    return this.apiService.put(`${environment.url.prefixCustoms}v2/management/global-alerts/${id}`, data, null, { isShowLoader });
  }

  public deleteGlobalAlert(id: number, isShowLoader?: boolean): Observable<void> {
    return this.apiService.delete(`${environment.url.prefixCustoms}v2/management/global-alerts/${id}`, null, { isShowLoader });
  }
}
